import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';

import useKioskIdleTimer from './kiosk-idle-timer.controller';

const ID = 'kiosk-idle-timer';

const KioskIdleTimer = () => {
    const viewProps = useKioskIdleTimer();

    if (!viewProps.enabled) return <></>;
    if (!viewProps.almostInActive) return <></>;

    return createPortal(
        <div
            onClick={viewProps.onClick}
            id={ID}
            className='fixed inset-0 z-[99999] flex items-center justify-center'>
            <div
                className='bg-foreground-default/40 absolute inset-0'
                aria-hidden
            />
            <div className='bg-background-surface relative m-4 overflow-hidden rounded-xl p-4'>
                <FormattedMessage
                    id='kiosk.IdleTimer.InactivityMessage'
                    description='Message shown to user when they are about to be redirected to home screen due to inactivity.'
                    defaultMessage='Are you still there? Returning to home screen in {redirectInSeconds} seconds'
                    values={{ redirectInSeconds: viewProps.timeUntilInactive }}
                />
                <div className='mt-4 w-full'>
                    <button
                        onClick={viewProps.onClick}
                        id='stay-active-button'
                        data-testid='stay-active-button'
                        className='bg-brand-primary inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3'>
                        <span className='text-background-surface justify-start text-base font-medium'>
                            <FormattedMessage
                                id='kiosk.IdleTimer.StayActive'
                                description='Button text to stay active on the current screen.'
                                defaultMessage='Stay active'
                            />
                        </span>
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default KioskIdleTimer;
